// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/myprofile/v1/my_profile_api.proto (package gdx.gateway.web.myprofile.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, protoInt64, StringValue, Timestamp } from "@bufbuild/protobuf";
import { AccountStatus, CodeType } from "../../../../common/v1/profile_pb.js";
import { FullProfileInfo, LocationUpdateSource, ProfileBirthday, ProfileGender, ProfileLocation, ProfilePhoto } from "../../profile/v1/profile_pb.js";
import { CursorPaginationRequest, CursorPaginationResponse } from "../../../../common/v1/pagination_pb.js";
import { EmailCredential, ExternalCredential, OneTimeHashCredential, RefreshTokenCredential, Token, ValidateEmailResponseCode } from "./auth_pb.js";
import { TopProfileMode } from "./top_profile_pb.js";
import { ProfileField } from "../../profile/v1/update_pb.js";
import { UserFeature } from "./feature_pb.js";
import { LifecycleProgress } from "./lifecycle_pb.js";
import { CameBackEvent, OnboardingCompleteClientEvent, ProfileVisitedEvent, RouteVisitedEvent, SurveyType, WebPushClickClientEvent } from "./client_events_pb.js";
import { CardsViewedEvent } from "../../profile/v1/client_events_pb.js";

/**
 * @generated from message gdx.gateway.web.myprofile.v1.ValidateConfirmationCodeRequest
 */
export class ValidateConfirmationCodeRequest extends Message<ValidateConfirmationCodeRequest> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: gdx.common.v1.CodeType code_type = 2;
   */
  codeType = CodeType.INVALID;

  constructor(data?: PartialMessage<ValidateConfirmationCodeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ValidateConfirmationCodeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code_type", kind: "enum", T: proto3.getEnumType(CodeType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateConfirmationCodeRequest {
    return new ValidateConfirmationCodeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateConfirmationCodeRequest {
    return new ValidateConfirmationCodeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateConfirmationCodeRequest {
    return new ValidateConfirmationCodeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateConfirmationCodeRequest | PlainMessage<ValidateConfirmationCodeRequest> | undefined, b: ValidateConfirmationCodeRequest | PlainMessage<ValidateConfirmationCodeRequest> | undefined): boolean {
    return proto3.util.equals(ValidateConfirmationCodeRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.ValidateConfirmationCodeResponse
 */
export class ValidateConfirmationCodeResponse extends Message<ValidateConfirmationCodeResponse> {
  constructor(data?: PartialMessage<ValidateConfirmationCodeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ValidateConfirmationCodeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateConfirmationCodeResponse {
    return new ValidateConfirmationCodeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateConfirmationCodeResponse {
    return new ValidateConfirmationCodeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateConfirmationCodeResponse {
    return new ValidateConfirmationCodeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateConfirmationCodeResponse | PlainMessage<ValidateConfirmationCodeResponse> | undefined, b: ValidateConfirmationCodeResponse | PlainMessage<ValidateConfirmationCodeResponse> | undefined): boolean {
    return proto3.util.equals(ValidateConfirmationCodeResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SendConfirmationCodeRequest
 */
export class SendConfirmationCodeRequest extends Message<SendConfirmationCodeRequest> {
  /**
   * optional email to send code.
   *
   * @generated from field: google.protobuf.StringValue email = 1;
   */
  email?: string;

  /**
   * determinate what type of code must be generated and side effects applied.
   *
   * @generated from field: gdx.common.v1.CodeType code_type = 2;
   */
  codeType = CodeType.INVALID;

  constructor(data?: PartialMessage<SendConfirmationCodeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SendConfirmationCodeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "message", T: StringValue },
    { no: 2, name: "code_type", kind: "enum", T: proto3.getEnumType(CodeType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendConfirmationCodeRequest {
    return new SendConfirmationCodeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendConfirmationCodeRequest {
    return new SendConfirmationCodeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendConfirmationCodeRequest {
    return new SendConfirmationCodeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendConfirmationCodeRequest | PlainMessage<SendConfirmationCodeRequest> | undefined, b: SendConfirmationCodeRequest | PlainMessage<SendConfirmationCodeRequest> | undefined): boolean {
    return proto3.util.equals(SendConfirmationCodeRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SendConfirmationCodeResponse
 */
export class SendConfirmationCodeResponse extends Message<SendConfirmationCodeResponse> {
  constructor(data?: PartialMessage<SendConfirmationCodeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SendConfirmationCodeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendConfirmationCodeResponse {
    return new SendConfirmationCodeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendConfirmationCodeResponse {
    return new SendConfirmationCodeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendConfirmationCodeResponse {
    return new SendConfirmationCodeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendConfirmationCodeResponse | PlainMessage<SendConfirmationCodeResponse> | undefined, b: SendConfirmationCodeResponse | PlainMessage<SendConfirmationCodeResponse> | undefined): boolean {
    return proto3.util.equals(SendConfirmationCodeResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SelectPrimaryAccountRequest
 */
export class SelectPrimaryAccountRequest extends Message<SelectPrimaryAccountRequest> {
  /**
   * @generated from field: string list_id = 1;
   */
  listId = "";

  /**
   * @generated from field: string profile_id = 2;
   */
  profileId = "";

  constructor(data?: PartialMessage<SelectPrimaryAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SelectPrimaryAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "list_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SelectPrimaryAccountRequest {
    return new SelectPrimaryAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SelectPrimaryAccountRequest {
    return new SelectPrimaryAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SelectPrimaryAccountRequest {
    return new SelectPrimaryAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SelectPrimaryAccountRequest | PlainMessage<SelectPrimaryAccountRequest> | undefined, b: SelectPrimaryAccountRequest | PlainMessage<SelectPrimaryAccountRequest> | undefined): boolean {
    return proto3.util.equals(SelectPrimaryAccountRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SelectPrimaryAccountResponse
 */
export class SelectPrimaryAccountResponse extends Message<SelectPrimaryAccountResponse> {
  /**
   * @generated from field: string autologin_hash = 1;
   */
  autologinHash = "";

  constructor(data?: PartialMessage<SelectPrimaryAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SelectPrimaryAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "autologin_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SelectPrimaryAccountResponse {
    return new SelectPrimaryAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SelectPrimaryAccountResponse {
    return new SelectPrimaryAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SelectPrimaryAccountResponse {
    return new SelectPrimaryAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SelectPrimaryAccountResponse | PlainMessage<SelectPrimaryAccountResponse> | undefined, b: SelectPrimaryAccountResponse | PlainMessage<SelectPrimaryAccountResponse> | undefined): boolean {
    return proto3.util.equals(SelectPrimaryAccountResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetDuplicateStateRequest
 */
export class GetDuplicateStateRequest extends Message<GetDuplicateStateRequest> {
  /**
   * @generated from field: string list_id = 1;
   */
  listId = "";

  constructor(data?: PartialMessage<GetDuplicateStateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetDuplicateStateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "list_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDuplicateStateRequest {
    return new GetDuplicateStateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDuplicateStateRequest {
    return new GetDuplicateStateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDuplicateStateRequest {
    return new GetDuplicateStateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetDuplicateStateRequest | PlainMessage<GetDuplicateStateRequest> | undefined, b: GetDuplicateStateRequest | PlainMessage<GetDuplicateStateRequest> | undefined): boolean {
    return proto3.util.equals(GetDuplicateStateRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetDuplicateStateResponse
 */
export class GetDuplicateStateResponse extends Message<GetDuplicateStateResponse> {
  /**
   * @generated from oneof gdx.gateway.web.myprofile.v1.GetDuplicateStateResponse.selection
   */
  selection: {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.GetDuplicateStateResponse.ProfileSelected profile = 1;
     */
    value: GetDuplicateStateResponse_ProfileSelected;
    case: "profile";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.GetDuplicateStateResponse.SelectionCandidates selection_candidates = 2;
     */
    value: GetDuplicateStateResponse_SelectionCandidates;
    case: "selectionCandidates";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<GetDuplicateStateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetDuplicateStateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile", kind: "message", T: GetDuplicateStateResponse_ProfileSelected, oneof: "selection" },
    { no: 2, name: "selection_candidates", kind: "message", T: GetDuplicateStateResponse_SelectionCandidates, oneof: "selection" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDuplicateStateResponse {
    return new GetDuplicateStateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDuplicateStateResponse {
    return new GetDuplicateStateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDuplicateStateResponse {
    return new GetDuplicateStateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetDuplicateStateResponse | PlainMessage<GetDuplicateStateResponse> | undefined, b: GetDuplicateStateResponse | PlainMessage<GetDuplicateStateResponse> | undefined): boolean {
    return proto3.util.equals(GetDuplicateStateResponse, a, b);
  }
}

/**
 * Describes state when primary profile is already selected.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.GetDuplicateStateResponse.ProfileSelected
 */
export class GetDuplicateStateResponse_ProfileSelected extends Message<GetDuplicateStateResponse_ProfileSelected> {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId = "";

  constructor(data?: PartialMessage<GetDuplicateStateResponse_ProfileSelected>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetDuplicateStateResponse.ProfileSelected";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDuplicateStateResponse_ProfileSelected {
    return new GetDuplicateStateResponse_ProfileSelected().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDuplicateStateResponse_ProfileSelected {
    return new GetDuplicateStateResponse_ProfileSelected().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDuplicateStateResponse_ProfileSelected {
    return new GetDuplicateStateResponse_ProfileSelected().fromJsonString(jsonString, options);
  }

  static equals(a: GetDuplicateStateResponse_ProfileSelected | PlainMessage<GetDuplicateStateResponse_ProfileSelected> | undefined, b: GetDuplicateStateResponse_ProfileSelected | PlainMessage<GetDuplicateStateResponse_ProfileSelected> | undefined): boolean {
    return proto3.util.equals(GetDuplicateStateResponse_ProfileSelected, a, b);
  }
}

/**
 * Describes state when primary account is not selected.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.GetDuplicateStateResponse.SelectionCandidates
 */
export class GetDuplicateStateResponse_SelectionCandidates extends Message<GetDuplicateStateResponse_SelectionCandidates> {
  /**
   * @generated from field: repeated string profile_ids = 1;
   */
  profileIds: string[] = [];

  constructor(data?: PartialMessage<GetDuplicateStateResponse_SelectionCandidates>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetDuplicateStateResponse.SelectionCandidates";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDuplicateStateResponse_SelectionCandidates {
    return new GetDuplicateStateResponse_SelectionCandidates().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDuplicateStateResponse_SelectionCandidates {
    return new GetDuplicateStateResponse_SelectionCandidates().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDuplicateStateResponse_SelectionCandidates {
    return new GetDuplicateStateResponse_SelectionCandidates().fromJsonString(jsonString, options);
  }

  static equals(a: GetDuplicateStateResponse_SelectionCandidates | PlainMessage<GetDuplicateStateResponse_SelectionCandidates> | undefined, b: GetDuplicateStateResponse_SelectionCandidates | PlainMessage<GetDuplicateStateResponse_SelectionCandidates> | undefined): boolean {
    return proto3.util.equals(GetDuplicateStateResponse_SelectionCandidates, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetTikTokRoutingRequest
 */
export class GetTikTokRoutingRequest extends Message<GetTikTokRoutingRequest> {
  /**
   * @generated from field: gdx.gateway.web.myprofile.v1.GetTikTokRoutingRequest.RoutingParams params = 1;
   */
  params?: GetTikTokRoutingRequest_RoutingParams;

  constructor(data?: PartialMessage<GetTikTokRoutingRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetTikTokRoutingRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "params", kind: "message", T: GetTikTokRoutingRequest_RoutingParams },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTikTokRoutingRequest {
    return new GetTikTokRoutingRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTikTokRoutingRequest {
    return new GetTikTokRoutingRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTikTokRoutingRequest {
    return new GetTikTokRoutingRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTikTokRoutingRequest | PlainMessage<GetTikTokRoutingRequest> | undefined, b: GetTikTokRoutingRequest | PlainMessage<GetTikTokRoutingRequest> | undefined): boolean {
    return proto3.util.equals(GetTikTokRoutingRequest, a, b);
  }
}

/**
 * Describes required params to determine tracking for unregistered user. Is ignored after auth.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.GetTikTokRoutingRequest.RoutingParams
 */
export class GetTikTokRoutingRequest_RoutingParams extends Message<GetTikTokRoutingRequest_RoutingParams> {
  /**
   * @generated from field: string landing_url = 1;
   */
  landingUrl = "";

  constructor(data?: PartialMessage<GetTikTokRoutingRequest_RoutingParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetTikTokRoutingRequest.RoutingParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "landing_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTikTokRoutingRequest_RoutingParams {
    return new GetTikTokRoutingRequest_RoutingParams().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTikTokRoutingRequest_RoutingParams {
    return new GetTikTokRoutingRequest_RoutingParams().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTikTokRoutingRequest_RoutingParams {
    return new GetTikTokRoutingRequest_RoutingParams().fromJsonString(jsonString, options);
  }

  static equals(a: GetTikTokRoutingRequest_RoutingParams | PlainMessage<GetTikTokRoutingRequest_RoutingParams> | undefined, b: GetTikTokRoutingRequest_RoutingParams | PlainMessage<GetTikTokRoutingRequest_RoutingParams> | undefined): boolean {
    return proto3.util.equals(GetTikTokRoutingRequest_RoutingParams, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetTikTokRoutingResponse
 */
export class GetTikTokRoutingResponse extends Message<GetTikTokRoutingResponse> {
  /**
   * @generated from field: string pixel_id = 1;
   */
  pixelId = "";

  constructor(data?: PartialMessage<GetTikTokRoutingResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetTikTokRoutingResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pixel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTikTokRoutingResponse {
    return new GetTikTokRoutingResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTikTokRoutingResponse {
    return new GetTikTokRoutingResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTikTokRoutingResponse {
    return new GetTikTokRoutingResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTikTokRoutingResponse | PlainMessage<GetTikTokRoutingResponse> | undefined, b: GetTikTokRoutingResponse | PlainMessage<GetTikTokRoutingResponse> | undefined): boolean {
    return proto3.util.equals(GetTikTokRoutingResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SetSettingsRequest
 */
export class SetSettingsRequest extends Message<SetSettingsRequest> {
  /**
   * @generated from oneof gdx.gateway.web.myprofile.v1.SetSettingsRequest.field
   */
  field: {
    /**
     * @generated from field: bool set_hidden_from_search = 1;
     */
    value: boolean;
    case: "setHiddenFromSearch";
  } | {
    /**
     * @generated from field: bool set_ai_generation_allowed = 2;
     */
    value: boolean;
    case: "setAiGenerationAllowed";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<SetSettingsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SetSettingsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "set_hidden_from_search", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "field" },
    { no: 2, name: "set_ai_generation_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "field" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetSettingsRequest {
    return new SetSettingsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetSettingsRequest {
    return new SetSettingsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetSettingsRequest {
    return new SetSettingsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetSettingsRequest | PlainMessage<SetSettingsRequest> | undefined, b: SetSettingsRequest | PlainMessage<SetSettingsRequest> | undefined): boolean {
    return proto3.util.equals(SetSettingsRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SetSettingsResponse
 */
export class SetSettingsResponse extends Message<SetSettingsResponse> {
  constructor(data?: PartialMessage<SetSettingsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SetSettingsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetSettingsResponse {
    return new SetSettingsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetSettingsResponse {
    return new SetSettingsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetSettingsResponse {
    return new SetSettingsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetSettingsResponse | PlainMessage<SetSettingsResponse> | undefined, b: SetSettingsResponse | PlainMessage<SetSettingsResponse> | undefined): boolean {
    return proto3.util.equals(SetSettingsResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetTrustPilotReviewFormURLRequest
 */
export class GetTrustPilotReviewFormURLRequest extends Message<GetTrustPilotReviewFormURLRequest> {
  constructor(data?: PartialMessage<GetTrustPilotReviewFormURLRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetTrustPilotReviewFormURLRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTrustPilotReviewFormURLRequest {
    return new GetTrustPilotReviewFormURLRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTrustPilotReviewFormURLRequest {
    return new GetTrustPilotReviewFormURLRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTrustPilotReviewFormURLRequest {
    return new GetTrustPilotReviewFormURLRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTrustPilotReviewFormURLRequest | PlainMessage<GetTrustPilotReviewFormURLRequest> | undefined, b: GetTrustPilotReviewFormURLRequest | PlainMessage<GetTrustPilotReviewFormURLRequest> | undefined): boolean {
    return proto3.util.equals(GetTrustPilotReviewFormURLRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetTrustPilotReviewFormURLResponse
 */
export class GetTrustPilotReviewFormURLResponse extends Message<GetTrustPilotReviewFormURLResponse> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  constructor(data?: PartialMessage<GetTrustPilotReviewFormURLResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetTrustPilotReviewFormURLResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTrustPilotReviewFormURLResponse {
    return new GetTrustPilotReviewFormURLResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTrustPilotReviewFormURLResponse {
    return new GetTrustPilotReviewFormURLResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTrustPilotReviewFormURLResponse {
    return new GetTrustPilotReviewFormURLResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTrustPilotReviewFormURLResponse | PlainMessage<GetTrustPilotReviewFormURLResponse> | undefined, b: GetTrustPilotReviewFormURLResponse | PlainMessage<GetTrustPilotReviewFormURLResponse> | undefined): boolean {
    return proto3.util.equals(GetTrustPilotReviewFormURLResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SubmitTrustPilotReviewRequest
 */
export class SubmitTrustPilotReviewRequest extends Message<SubmitTrustPilotReviewRequest> {
  constructor(data?: PartialMessage<SubmitTrustPilotReviewRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SubmitTrustPilotReviewRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitTrustPilotReviewRequest {
    return new SubmitTrustPilotReviewRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitTrustPilotReviewRequest {
    return new SubmitTrustPilotReviewRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitTrustPilotReviewRequest {
    return new SubmitTrustPilotReviewRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitTrustPilotReviewRequest | PlainMessage<SubmitTrustPilotReviewRequest> | undefined, b: SubmitTrustPilotReviewRequest | PlainMessage<SubmitTrustPilotReviewRequest> | undefined): boolean {
    return proto3.util.equals(SubmitTrustPilotReviewRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SubmitTrustPilotReviewResponse
 */
export class SubmitTrustPilotReviewResponse extends Message<SubmitTrustPilotReviewResponse> {
  constructor(data?: PartialMessage<SubmitTrustPilotReviewResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SubmitTrustPilotReviewResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitTrustPilotReviewResponse {
    return new SubmitTrustPilotReviewResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitTrustPilotReviewResponse {
    return new SubmitTrustPilotReviewResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitTrustPilotReviewResponse {
    return new SubmitTrustPilotReviewResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitTrustPilotReviewResponse | PlainMessage<SubmitTrustPilotReviewResponse> | undefined, b: SubmitTrustPilotReviewResponse | PlainMessage<SubmitTrustPilotReviewResponse> | undefined): boolean {
    return proto3.util.equals(SubmitTrustPilotReviewResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.ListNamesRequest
 */
export class ListNamesRequest extends Message<ListNamesRequest> {
  /**
   * filters by name
   *
   * @generated from field: string filter = 1;
   */
  filter = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileGender gender = 2;
   */
  gender = ProfileGender.INVALID;

  /**
   * @generated from field: gdx.common.v1.CursorPaginationRequest pagination = 3;
   */
  pagination?: CursorPaginationRequest;

  constructor(data?: PartialMessage<ListNamesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ListNamesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 3, name: "pagination", kind: "message", T: CursorPaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListNamesRequest {
    return new ListNamesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListNamesRequest {
    return new ListNamesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListNamesRequest {
    return new ListNamesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListNamesRequest | PlainMessage<ListNamesRequest> | undefined, b: ListNamesRequest | PlainMessage<ListNamesRequest> | undefined): boolean {
    return proto3.util.equals(ListNamesRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.ListNamesResponse
 */
export class ListNamesResponse extends Message<ListNamesResponse> {
  /**
   * @generated from field: repeated string names = 1;
   */
  names: string[] = [];

  /**
   * @generated from field: gdx.common.v1.CursorPaginationResponse pagination = 2;
   */
  pagination?: CursorPaginationResponse;

  constructor(data?: PartialMessage<ListNamesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ListNamesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: CursorPaginationResponse },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListNamesResponse {
    return new ListNamesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListNamesResponse {
    return new ListNamesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListNamesResponse {
    return new ListNamesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListNamesResponse | PlainMessage<ListNamesResponse> | undefined, b: ListNamesResponse | PlainMessage<ListNamesResponse> | undefined): boolean {
    return proto3.util.equals(ListNamesResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.ListProfileTagsRequest
 */
export class ListProfileTagsRequest extends Message<ListProfileTagsRequest> {
  constructor(data?: PartialMessage<ListProfileTagsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ListProfileTagsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListProfileTagsRequest {
    return new ListProfileTagsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListProfileTagsRequest {
    return new ListProfileTagsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListProfileTagsRequest {
    return new ListProfileTagsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListProfileTagsRequest | PlainMessage<ListProfileTagsRequest> | undefined, b: ListProfileTagsRequest | PlainMessage<ListProfileTagsRequest> | undefined): boolean {
    return proto3.util.equals(ListProfileTagsRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.ListProfileTagsResponse
 */
export class ListProfileTagsResponse extends Message<ListProfileTagsResponse> {
  /**
   * @generated from field: repeated string tags = 1;
   */
  tags: string[] = [];

  constructor(data?: PartialMessage<ListProfileTagsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ListProfileTagsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListProfileTagsResponse {
    return new ListProfileTagsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListProfileTagsResponse {
    return new ListProfileTagsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListProfileTagsResponse {
    return new ListProfileTagsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListProfileTagsResponse | PlainMessage<ListProfileTagsResponse> | undefined, b: ListProfileTagsResponse | PlainMessage<ListProfileTagsResponse> | undefined): boolean {
    return proto3.util.equals(ListProfileTagsResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetIsBookPurchasedRequest
 */
export class GetIsBookPurchasedRequest extends Message<GetIsBookPurchasedRequest> {
  constructor(data?: PartialMessage<GetIsBookPurchasedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetIsBookPurchasedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIsBookPurchasedRequest {
    return new GetIsBookPurchasedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIsBookPurchasedRequest {
    return new GetIsBookPurchasedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIsBookPurchasedRequest {
    return new GetIsBookPurchasedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetIsBookPurchasedRequest | PlainMessage<GetIsBookPurchasedRequest> | undefined, b: GetIsBookPurchasedRequest | PlainMessage<GetIsBookPurchasedRequest> | undefined): boolean {
    return proto3.util.equals(GetIsBookPurchasedRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetIsBookPurchasedResponse
 */
export class GetIsBookPurchasedResponse extends Message<GetIsBookPurchasedResponse> {
  /**
   * @generated from field: bool purchased = 1;
   */
  purchased = false;

  constructor(data?: PartialMessage<GetIsBookPurchasedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetIsBookPurchasedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchased", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIsBookPurchasedResponse {
    return new GetIsBookPurchasedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIsBookPurchasedResponse {
    return new GetIsBookPurchasedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIsBookPurchasedResponse {
    return new GetIsBookPurchasedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetIsBookPurchasedResponse | PlainMessage<GetIsBookPurchasedResponse> | undefined, b: GetIsBookPurchasedResponse | PlainMessage<GetIsBookPurchasedResponse> | undefined): boolean {
    return proto3.util.equals(GetIsBookPurchasedResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SignUpRequest
 */
export class SignUpRequest extends Message<SignUpRequest> {
  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileGender match_gender = 1;
   */
  matchGender = ProfileGender.INVALID;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileGender gender = 2;
   */
  gender = ProfileGender.INVALID;

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileBirthday birthday = 4;
   */
  birthday?: ProfileBirthday;

  /**
   * @generated from field: bool is_subscribed_to_mails = 5;
   */
  isSubscribedToMails = false;

  /**
   * @generated from field: gdx.gateway.web.myprofile.v1.ExternalCredential external_credential = 6;
   */
  externalCredential?: ExternalCredential;

  /**
   * @generated from field: gdx.gateway.web.myprofile.v1.EmailCredential email_credential = 7;
   */
  emailCredential?: EmailCredential;

  /**
   * Optional. Should be used in cases when signup type is not EmailCredential. Passed email will be used for notifications, letters, etc.
   *
   * @generated from field: string email = 8;
   */
  email = "";

  /**
   * @generated from field: string browser_id = 9;
   */
  browserId = "";

  /**
   * @generated from field: string user_id = 10;
   */
  userId = "";

  /**
   * 0 - regular mirror
   * 1 - spanish mirror
   *
   * @generated from field: int32 mirror_id = 11;
   */
  mirrorId = 0;

  /**
   * `es_419` - Spanish (Latin America)
   * `en_US` - English (United States)
   *
   * @generated from field: string interface_language = 12;
   */
  interfaceLanguage = "";

  /**
   * @generated from field: bool is_ai_generation_allowed = 13;
   */
  isAiGenerationAllowed = false;

  constructor(data?: PartialMessage<SignUpRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SignUpRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "match_gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 2, name: "gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "birthday", kind: "message", T: ProfileBirthday },
    { no: 5, name: "is_subscribed_to_mails", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "external_credential", kind: "message", T: ExternalCredential },
    { no: 7, name: "email_credential", kind: "message", T: EmailCredential },
    { no: 8, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "browser_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "mirror_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "interface_language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "is_ai_generation_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignUpRequest {
    return new SignUpRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignUpRequest {
    return new SignUpRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignUpRequest {
    return new SignUpRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SignUpRequest | PlainMessage<SignUpRequest> | undefined, b: SignUpRequest | PlainMessage<SignUpRequest> | undefined): boolean {
    return proto3.util.equals(SignUpRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SignUpResponse
 */
export class SignUpResponse extends Message<SignUpResponse> {
  /**
   * @generated from field: gdx.gateway.web.myprofile.v1.Token access_token = 1;
   */
  accessToken?: Token;

  /**
   * @generated from field: gdx.gateway.web.myprofile.v1.Token refresh_token = 3;
   */
  refreshToken?: Token;

  /**
   * @generated from field: string user_id = 4;
   */
  userId = "";

  constructor(data?: PartialMessage<SignUpResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SignUpResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "access_token", kind: "message", T: Token },
    { no: 3, name: "refresh_token", kind: "message", T: Token },
    { no: 4, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignUpResponse {
    return new SignUpResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignUpResponse {
    return new SignUpResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignUpResponse {
    return new SignUpResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SignUpResponse | PlainMessage<SignUpResponse> | undefined, b: SignUpResponse | PlainMessage<SignUpResponse> | undefined): boolean {
    return proto3.util.equals(SignUpResponse, a, b);
  }
}

/**
 * Supported providers:
 * provider = facebook.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.GetExternalUserInfoRequest
 */
export class GetExternalUserInfoRequest extends Message<GetExternalUserInfoRequest> {
  /**
   * @generated from field: string provider = 1;
   */
  provider = "";

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId = "";

  constructor(data?: PartialMessage<GetExternalUserInfoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetExternalUserInfoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetExternalUserInfoRequest {
    return new GetExternalUserInfoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetExternalUserInfoRequest {
    return new GetExternalUserInfoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetExternalUserInfoRequest {
    return new GetExternalUserInfoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetExternalUserInfoRequest | PlainMessage<GetExternalUserInfoRequest> | undefined, b: GetExternalUserInfoRequest | PlainMessage<GetExternalUserInfoRequest> | undefined): boolean {
    return proto3.util.equals(GetExternalUserInfoRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetExternalUserInfoResponse
 */
export class GetExternalUserInfoResponse extends Message<GetExternalUserInfoResponse> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string email = 2;
   */
  email = "";

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileGender gender = 4;
   */
  gender = ProfileGender.INVALID;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileBirthday birthday = 5;
   */
  birthday?: ProfileBirthday;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileLocation location = 6;
   */
  location?: ProfileLocation;

  constructor(data?: PartialMessage<GetExternalUserInfoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetExternalUserInfoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 5, name: "birthday", kind: "message", T: ProfileBirthday },
    { no: 6, name: "location", kind: "message", T: ProfileLocation },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetExternalUserInfoResponse {
    return new GetExternalUserInfoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetExternalUserInfoResponse {
    return new GetExternalUserInfoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetExternalUserInfoResponse {
    return new GetExternalUserInfoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetExternalUserInfoResponse | PlainMessage<GetExternalUserInfoResponse> | undefined, b: GetExternalUserInfoResponse | PlainMessage<GetExternalUserInfoResponse> | undefined): boolean {
    return proto3.util.equals(GetExternalUserInfoResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.ValidateEmailRequest
 */
export class ValidateEmailRequest extends Message<ValidateEmailRequest> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  constructor(data?: PartialMessage<ValidateEmailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ValidateEmailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateEmailRequest {
    return new ValidateEmailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateEmailRequest {
    return new ValidateEmailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateEmailRequest {
    return new ValidateEmailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateEmailRequest | PlainMessage<ValidateEmailRequest> | undefined, b: ValidateEmailRequest | PlainMessage<ValidateEmailRequest> | undefined): boolean {
    return proto3.util.equals(ValidateEmailRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.ValidateEmailResponse
 */
export class ValidateEmailResponse extends Message<ValidateEmailResponse> {
  /**
   * @generated from field: gdx.gateway.web.myprofile.v1.ValidateEmailResponseCode code = 1;
   */
  code = ValidateEmailResponseCode.INVALID;

  constructor(data?: PartialMessage<ValidateEmailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ValidateEmailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "enum", T: proto3.getEnumType(ValidateEmailResponseCode) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateEmailResponse {
    return new ValidateEmailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateEmailResponse {
    return new ValidateEmailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateEmailResponse {
    return new ValidateEmailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateEmailResponse | PlainMessage<ValidateEmailResponse> | undefined, b: ValidateEmailResponse | PlainMessage<ValidateEmailResponse> | undefined): boolean {
    return proto3.util.equals(ValidateEmailResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.CheckEmailRequest
 */
export class CheckEmailRequest extends Message<CheckEmailRequest> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  constructor(data?: PartialMessage<CheckEmailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.CheckEmailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckEmailRequest {
    return new CheckEmailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckEmailRequest {
    return new CheckEmailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckEmailRequest {
    return new CheckEmailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckEmailRequest | PlainMessage<CheckEmailRequest> | undefined, b: CheckEmailRequest | PlainMessage<CheckEmailRequest> | undefined): boolean {
    return proto3.util.equals(CheckEmailRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.CheckEmailResponse
 */
export class CheckEmailResponse extends Message<CheckEmailResponse> {
  /**
   * @generated from field: gdx.gateway.web.myprofile.v1.ValidateEmailResponseCode code = 1;
   */
  code = ValidateEmailResponseCode.INVALID;

  constructor(data?: PartialMessage<CheckEmailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.CheckEmailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "enum", T: proto3.getEnumType(ValidateEmailResponseCode) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckEmailResponse {
    return new CheckEmailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckEmailResponse {
    return new CheckEmailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckEmailResponse {
    return new CheckEmailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CheckEmailResponse | PlainMessage<CheckEmailResponse> | undefined, b: CheckEmailResponse | PlainMessage<CheckEmailResponse> | undefined): boolean {
    return proto3.util.equals(CheckEmailResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SignInRequest
 */
export class SignInRequest extends Message<SignInRequest> {
  /**
   * @generated from oneof gdx.gateway.web.myprofile.v1.SignInRequest.credential
   */
  credential: {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.ExternalCredential external_credential = 1;
     */
    value: ExternalCredential;
    case: "externalCredential";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.EmailCredential email_credential = 2;
     */
    value: EmailCredential;
    case: "emailCredential";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.OneTimeHashCredential onetime_credential = 3;
     */
    value: OneTimeHashCredential;
    case: "onetimeCredential";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.RefreshTokenCredential refresh_token = 4;
     */
    value: RefreshTokenCredential;
    case: "refreshToken";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * @generated from field: string landing_url = 5;
   */
  landingUrl = "";

  constructor(data?: PartialMessage<SignInRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SignInRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "external_credential", kind: "message", T: ExternalCredential, oneof: "credential" },
    { no: 2, name: "email_credential", kind: "message", T: EmailCredential, oneof: "credential" },
    { no: 3, name: "onetime_credential", kind: "message", T: OneTimeHashCredential, oneof: "credential" },
    { no: 4, name: "refresh_token", kind: "message", T: RefreshTokenCredential, oneof: "credential" },
    { no: 5, name: "landing_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignInRequest {
    return new SignInRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignInRequest {
    return new SignInRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignInRequest {
    return new SignInRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SignInRequest | PlainMessage<SignInRequest> | undefined, b: SignInRequest | PlainMessage<SignInRequest> | undefined): boolean {
    return proto3.util.equals(SignInRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SignInResponse
 */
export class SignInResponse extends Message<SignInResponse> {
  /**
   * @generated from field: gdx.gateway.web.myprofile.v1.Token access_token = 1;
   */
  accessToken?: Token;

  /**
   * @generated from field: gdx.gateway.web.myprofile.v1.Token refresh_token = 3;
   */
  refreshToken?: Token;

  /**
   * @generated from field: string user_id = 4;
   */
  userId = "";

  constructor(data?: PartialMessage<SignInResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SignInResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "access_token", kind: "message", T: Token },
    { no: 3, name: "refresh_token", kind: "message", T: Token },
    { no: 4, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignInResponse {
    return new SignInResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignInResponse {
    return new SignInResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignInResponse {
    return new SignInResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SignInResponse | PlainMessage<SignInResponse> | undefined, b: SignInResponse | PlainMessage<SignInResponse> | undefined): boolean {
    return proto3.util.equals(SignInResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SignOutRequest
 */
export class SignOutRequest extends Message<SignOutRequest> {
  constructor(data?: PartialMessage<SignOutRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SignOutRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignOutRequest {
    return new SignOutRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignOutRequest {
    return new SignOutRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignOutRequest {
    return new SignOutRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SignOutRequest | PlainMessage<SignOutRequest> | undefined, b: SignOutRequest | PlainMessage<SignOutRequest> | undefined): boolean {
    return proto3.util.equals(SignOutRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SignOutResponse
 */
export class SignOutResponse extends Message<SignOutResponse> {
  constructor(data?: PartialMessage<SignOutResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SignOutResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignOutResponse {
    return new SignOutResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignOutResponse {
    return new SignOutResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignOutResponse {
    return new SignOutResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SignOutResponse | PlainMessage<SignOutResponse> | undefined, b: SignOutResponse | PlainMessage<SignOutResponse> | undefined): boolean {
    return proto3.util.equals(SignOutResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SendPasswordRestorationRequest
 */
export class SendPasswordRestorationRequest extends Message<SendPasswordRestorationRequest> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  /**
   * @generated from field: string confirmation_page_url = 2;
   */
  confirmationPageUrl = "";

  constructor(data?: PartialMessage<SendPasswordRestorationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SendPasswordRestorationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "confirmation_page_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendPasswordRestorationRequest {
    return new SendPasswordRestorationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendPasswordRestorationRequest {
    return new SendPasswordRestorationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendPasswordRestorationRequest {
    return new SendPasswordRestorationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendPasswordRestorationRequest | PlainMessage<SendPasswordRestorationRequest> | undefined, b: SendPasswordRestorationRequest | PlainMessage<SendPasswordRestorationRequest> | undefined): boolean {
    return proto3.util.equals(SendPasswordRestorationRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SendPasswordRestorationResponse
 */
export class SendPasswordRestorationResponse extends Message<SendPasswordRestorationResponse> {
  constructor(data?: PartialMessage<SendPasswordRestorationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SendPasswordRestorationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendPasswordRestorationResponse {
    return new SendPasswordRestorationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendPasswordRestorationResponse {
    return new SendPasswordRestorationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendPasswordRestorationResponse {
    return new SendPasswordRestorationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendPasswordRestorationResponse | PlainMessage<SendPasswordRestorationResponse> | undefined, b: SendPasswordRestorationResponse | PlainMessage<SendPasswordRestorationResponse> | undefined): boolean {
    return proto3.util.equals(SendPasswordRestorationResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.ConfirmNewPasswordRequest
 */
export class ConfirmNewPasswordRequest extends Message<ConfirmNewPasswordRequest> {
  /**
   * @generated from field: string session_hash = 1;
   */
  sessionHash = "";

  /**
   * @generated from field: string password = 2;
   */
  password = "";

  constructor(data?: PartialMessage<ConfirmNewPasswordRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ConfirmNewPasswordRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConfirmNewPasswordRequest {
    return new ConfirmNewPasswordRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConfirmNewPasswordRequest {
    return new ConfirmNewPasswordRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConfirmNewPasswordRequest {
    return new ConfirmNewPasswordRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ConfirmNewPasswordRequest | PlainMessage<ConfirmNewPasswordRequest> | undefined, b: ConfirmNewPasswordRequest | PlainMessage<ConfirmNewPasswordRequest> | undefined): boolean {
    return proto3.util.equals(ConfirmNewPasswordRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.ConfirmNewPasswordResponse
 */
export class ConfirmNewPasswordResponse extends Message<ConfirmNewPasswordResponse> {
  constructor(data?: PartialMessage<ConfirmNewPasswordResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ConfirmNewPasswordResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConfirmNewPasswordResponse {
    return new ConfirmNewPasswordResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConfirmNewPasswordResponse {
    return new ConfirmNewPasswordResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConfirmNewPasswordResponse {
    return new ConfirmNewPasswordResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ConfirmNewPasswordResponse | PlainMessage<ConfirmNewPasswordResponse> | undefined, b: ConfirmNewPasswordResponse | PlainMessage<ConfirmNewPasswordResponse> | undefined): boolean {
    return proto3.util.equals(ConfirmNewPasswordResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetShortProfileRequest
 */
export class GetShortProfileRequest extends Message<GetShortProfileRequest> {
  constructor(data?: PartialMessage<GetShortProfileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetShortProfileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetShortProfileRequest {
    return new GetShortProfileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetShortProfileRequest {
    return new GetShortProfileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetShortProfileRequest {
    return new GetShortProfileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetShortProfileRequest | PlainMessage<GetShortProfileRequest> | undefined, b: GetShortProfileRequest | PlainMessage<GetShortProfileRequest> | undefined): boolean {
    return proto3.util.equals(GetShortProfileRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetShortProfileResponse
 */
export class GetShortProfileResponse extends Message<GetShortProfileResponse> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto avatar = 2;
   */
  avatar?: ProfilePhoto;

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: uint32 age = 4;
   */
  age = 0;

  /**
   * @generated from field: int64 credits_count = 5;
   */
  creditsCount = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Duration booster_ends_duration = 8;
   */
  boosterEndsDuration?: Duration;

  /**
   * @generated from field: string zodiac = 9;
   */
  zodiac = "";

  /**
   * @generated from field: repeated gdx.gateway.web.myprofile.v1.TopProfileMode top_profile_mode = 10;
   */
  topProfileMode: TopProfileMode[] = [];

  /**
   * how much time left until top profile ends
   *
   * @generated from field: google.protobuf.Timestamp booster_ends_time = 11;
   */
  boosterEndsTime?: Timestamp;

  constructor(data?: PartialMessage<GetShortProfileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetShortProfileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "avatar", kind: "message", T: ProfilePhoto },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "credits_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "booster_ends_duration", kind: "message", T: Duration },
    { no: 9, name: "zodiac", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "top_profile_mode", kind: "enum", T: proto3.getEnumType(TopProfileMode), repeated: true },
    { no: 11, name: "booster_ends_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetShortProfileResponse {
    return new GetShortProfileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetShortProfileResponse {
    return new GetShortProfileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetShortProfileResponse {
    return new GetShortProfileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetShortProfileResponse | PlainMessage<GetShortProfileResponse> | undefined, b: GetShortProfileResponse | PlainMessage<GetShortProfileResponse> | undefined): boolean {
    return proto3.util.equals(GetShortProfileResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetFullProfileRequest
 */
export class GetFullProfileRequest extends Message<GetFullProfileRequest> {
  constructor(data?: PartialMessage<GetFullProfileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetFullProfileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFullProfileRequest {
    return new GetFullProfileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFullProfileRequest {
    return new GetFullProfileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFullProfileRequest {
    return new GetFullProfileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFullProfileRequest | PlainMessage<GetFullProfileRequest> | undefined, b: GetFullProfileRequest | PlainMessage<GetFullProfileRequest> | undefined): boolean {
    return proto3.util.equals(GetFullProfileRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetFullProfileResponse
 */
export class GetFullProfileResponse extends Message<GetFullProfileResponse> {
  /**
   * @generated from field: gdx.gateway.web.profile.v1.FullProfileInfo profile = 1;
   */
  profile?: FullProfileInfo;

  constructor(data?: PartialMessage<GetFullProfileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetFullProfileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile", kind: "message", T: FullProfileInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFullProfileResponse {
    return new GetFullProfileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFullProfileResponse {
    return new GetFullProfileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFullProfileResponse {
    return new GetFullProfileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFullProfileResponse | PlainMessage<GetFullProfileResponse> | undefined, b: GetFullProfileResponse | PlainMessage<GetFullProfileResponse> | undefined): boolean {
    return proto3.util.equals(GetFullProfileResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.UpdateAvatarRequest
 */
export class UpdateAvatarRequest extends Message<UpdateAvatarRequest> {
  /**
   * @generated from field: string photo_id = 1;
   */
  photoId = "";

  constructor(data?: PartialMessage<UpdateAvatarRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UpdateAvatarRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAvatarRequest {
    return new UpdateAvatarRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAvatarRequest {
    return new UpdateAvatarRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAvatarRequest {
    return new UpdateAvatarRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAvatarRequest | PlainMessage<UpdateAvatarRequest> | undefined, b: UpdateAvatarRequest | PlainMessage<UpdateAvatarRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAvatarRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.UpdateAvatarResponse
 */
export class UpdateAvatarResponse extends Message<UpdateAvatarResponse> {
  constructor(data?: PartialMessage<UpdateAvatarResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UpdateAvatarResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAvatarResponse {
    return new UpdateAvatarResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAvatarResponse {
    return new UpdateAvatarResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAvatarResponse {
    return new UpdateAvatarResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAvatarResponse | PlainMessage<UpdateAvatarResponse> | undefined, b: UpdateAvatarResponse | PlainMessage<UpdateAvatarResponse> | undefined): boolean {
    return proto3.util.equals(UpdateAvatarResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.UpdateProfileRequest
 */
export class UpdateProfileRequest extends Message<UpdateProfileRequest> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileField fields = 1;
   */
  fields: ProfileField[] = [];

  constructor(data?: PartialMessage<UpdateProfileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UpdateProfileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fields", kind: "message", T: ProfileField, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProfileRequest {
    return new UpdateProfileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProfileRequest {
    return new UpdateProfileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProfileRequest {
    return new UpdateProfileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProfileRequest | PlainMessage<UpdateProfileRequest> | undefined, b: UpdateProfileRequest | PlainMessage<UpdateProfileRequest> | undefined): boolean {
    return proto3.util.equals(UpdateProfileRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.UpdateProfileLocationRequest
 */
export class UpdateProfileLocationRequest extends Message<UpdateProfileLocationRequest> {
  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileLocation location = 1;
   */
  location?: ProfileLocation;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.LocationUpdateSource source = 2;
   */
  source = LocationUpdateSource.INVALID;

  constructor(data?: PartialMessage<UpdateProfileLocationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UpdateProfileLocationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "location", kind: "message", T: ProfileLocation },
    { no: 2, name: "source", kind: "enum", T: proto3.getEnumType(LocationUpdateSource) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProfileLocationRequest {
    return new UpdateProfileLocationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProfileLocationRequest {
    return new UpdateProfileLocationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProfileLocationRequest {
    return new UpdateProfileLocationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProfileLocationRequest | PlainMessage<UpdateProfileLocationRequest> | undefined, b: UpdateProfileLocationRequest | PlainMessage<UpdateProfileLocationRequest> | undefined): boolean {
    return proto3.util.equals(UpdateProfileLocationRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.UpdateProfileLocationResponse
 */
export class UpdateProfileLocationResponse extends Message<UpdateProfileLocationResponse> {
  constructor(data?: PartialMessage<UpdateProfileLocationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UpdateProfileLocationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProfileLocationResponse {
    return new UpdateProfileLocationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProfileLocationResponse {
    return new UpdateProfileLocationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProfileLocationResponse {
    return new UpdateProfileLocationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProfileLocationResponse | PlainMessage<UpdateProfileLocationResponse> | undefined, b: UpdateProfileLocationResponse | PlainMessage<UpdateProfileLocationResponse> | undefined): boolean {
    return proto3.util.equals(UpdateProfileLocationResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.UpdateProfileResponse
 */
export class UpdateProfileResponse extends Message<UpdateProfileResponse> {
  constructor(data?: PartialMessage<UpdateProfileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UpdateProfileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProfileResponse {
    return new UpdateProfileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProfileResponse {
    return new UpdateProfileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProfileResponse {
    return new UpdateProfileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProfileResponse | PlainMessage<UpdateProfileResponse> | undefined, b: UpdateProfileResponse | PlainMessage<UpdateProfileResponse> | undefined): boolean {
    return proto3.util.equals(UpdateProfileResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.UploadPhotoRequest
 */
export class UploadPhotoRequest extends Message<UploadPhotoRequest> {
  /**
   * @generated from field: string photo_id = 1;
   */
  photoId = "";

  constructor(data?: PartialMessage<UploadPhotoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UploadPhotoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadPhotoRequest {
    return new UploadPhotoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadPhotoRequest {
    return new UploadPhotoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadPhotoRequest {
    return new UploadPhotoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UploadPhotoRequest | PlainMessage<UploadPhotoRequest> | undefined, b: UploadPhotoRequest | PlainMessage<UploadPhotoRequest> | undefined): boolean {
    return proto3.util.equals(UploadPhotoRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.UploadPhotoResponse
 */
export class UploadPhotoResponse extends Message<UploadPhotoResponse> {
  /**
   * @generated from field: string photo_id = 1;
   */
  photoId = "";

  constructor(data?: PartialMessage<UploadPhotoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UploadPhotoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadPhotoResponse {
    return new UploadPhotoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadPhotoResponse {
    return new UploadPhotoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadPhotoResponse {
    return new UploadPhotoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UploadPhotoResponse | PlainMessage<UploadPhotoResponse> | undefined, b: UploadPhotoResponse | PlainMessage<UploadPhotoResponse> | undefined): boolean {
    return proto3.util.equals(UploadPhotoResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.DeletePhotoRequest
 */
export class DeletePhotoRequest extends Message<DeletePhotoRequest> {
  /**
   * @generated from field: string photo_id = 1;
   */
  photoId = "";

  constructor(data?: PartialMessage<DeletePhotoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.DeletePhotoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeletePhotoRequest {
    return new DeletePhotoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeletePhotoRequest {
    return new DeletePhotoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeletePhotoRequest {
    return new DeletePhotoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeletePhotoRequest | PlainMessage<DeletePhotoRequest> | undefined, b: DeletePhotoRequest | PlainMessage<DeletePhotoRequest> | undefined): boolean {
    return proto3.util.equals(DeletePhotoRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.DeletePhotoResponse
 */
export class DeletePhotoResponse extends Message<DeletePhotoResponse> {
  constructor(data?: PartialMessage<DeletePhotoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.DeletePhotoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeletePhotoResponse {
    return new DeletePhotoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeletePhotoResponse {
    return new DeletePhotoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeletePhotoResponse {
    return new DeletePhotoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeletePhotoResponse | PlainMessage<DeletePhotoResponse> | undefined, b: DeletePhotoResponse | PlainMessage<DeletePhotoResponse> | undefined): boolean {
    return proto3.util.equals(DeletePhotoResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetStateRequest
 */
export class GetStateRequest extends Message<GetStateRequest> {
  constructor(data?: PartialMessage<GetStateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetStateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStateRequest {
    return new GetStateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStateRequest {
    return new GetStateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStateRequest {
    return new GetStateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetStateRequest | PlainMessage<GetStateRequest> | undefined, b: GetStateRequest | PlainMessage<GetStateRequest> | undefined): boolean {
    return proto3.util.equals(GetStateRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetStateResponse
 */
export class GetStateResponse extends Message<GetStateResponse> {
  /**
   * @generated from field: uint32 new_likes_count = 1;
   */
  newLikesCount = 0;

  /**
   * @generated from field: uint32 new_chat_messages_count = 2;
   */
  newChatMessagesCount = 0;

  /**
   * @generated from field: bool is_email_verified = 3;
   */
  isEmailVerified = false;

  /**
   * @generated from field: string interface_language = 4;
   */
  interfaceLanguage = "";

  /**
   * @generated from field: int64 credits_count = 7;
   */
  creditsCount = protoInt64.zero;

  /**
   * @generated from field: repeated gdx.gateway.web.myprofile.v1.UserFeature user_features = 8;
   */
  userFeatures: UserFeature[] = [];

  /**
   * @generated from field: gdx.gateway.web.myprofile.v1.LifecycleProgress lifecycle = 10;
   */
  lifecycle?: LifecycleProgress;

  /**
   * @generated from field: bool has_new_activity = 11;
   */
  hasNewActivity = false;

  /**
   * @generated from field: string last_visited_route = 12;
   */
  lastVisitedRoute = "";

  /**
   * @generated from field: string landing_url = 13;
   */
  landingUrl = "";

  /**
   * @generated from field: gdx.common.v1.AccountStatus status = 14;
   */
  status = AccountStatus.INVALID;

  /**
   * @generated from field: int64 power_like_count = 15;
   */
  powerLikeCount = protoInt64.zero;

  /**
   * @generated from field: bool is_premium_gold_active = 16;
   */
  isPremiumGoldActive = false;

  /**
   * @generated from field: bool is_organic = 17;
   */
  isOrganic = false;

  /**
   * indicates that user is shadow-banned
   *
   * @generated from field: bool is_special = 18;
   */
  isSpecial = false;

  /**
   * @generated from field: bool is_hidden_from_search = 19;
   */
  isHiddenFromSearch = false;

  /**
   * @generated from field: bool is_ai_generation_allowed = 20;
   */
  isAiGenerationAllowed = false;

  constructor(data?: PartialMessage<GetStateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetStateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "new_likes_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "new_chat_messages_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "is_email_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "interface_language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "credits_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "user_features", kind: "message", T: UserFeature, repeated: true },
    { no: 10, name: "lifecycle", kind: "message", T: LifecycleProgress },
    { no: 11, name: "has_new_activity", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "last_visited_route", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "landing_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "status", kind: "enum", T: proto3.getEnumType(AccountStatus) },
    { no: 15, name: "power_like_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 16, name: "is_premium_gold_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "is_organic", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "is_special", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "is_hidden_from_search", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "is_ai_generation_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStateResponse {
    return new GetStateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStateResponse {
    return new GetStateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStateResponse {
    return new GetStateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetStateResponse | PlainMessage<GetStateResponse> | undefined, b: GetStateResponse | PlainMessage<GetStateResponse> | undefined): boolean {
    return proto3.util.equals(GetStateResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetAccountRequest
 */
export class GetAccountRequest extends Message<GetAccountRequest> {
  constructor(data?: PartialMessage<GetAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountRequest {
    return new GetAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountRequest {
    return new GetAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountRequest {
    return new GetAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountRequest | PlainMessage<GetAccountRequest> | undefined, b: GetAccountRequest | PlainMessage<GetAccountRequest> | undefined): boolean {
    return proto3.util.equals(GetAccountRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetAccountResponse
 */
export class GetAccountResponse extends Message<GetAccountResponse> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileBirthday birthday = 3;
   */
  birthday?: ProfileBirthday;

  /**
   * @generated from field: string email = 4;
   */
  email = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileGender gender = 5;
   */
  gender = ProfileGender.INVALID;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileLocation location = 6;
   */
  location?: ProfileLocation;

  /**
   * @generated from field: uint32 age = 7;
   */
  age = 0;

  constructor(data?: PartialMessage<GetAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "birthday", kind: "message", T: ProfileBirthday },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 6, name: "location", kind: "message", T: ProfileLocation },
    { no: 7, name: "age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountResponse {
    return new GetAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountResponse {
    return new GetAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountResponse {
    return new GetAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountResponse | PlainMessage<GetAccountResponse> | undefined, b: GetAccountResponse | PlainMessage<GetAccountResponse> | undefined): boolean {
    return proto3.util.equals(GetAccountResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.DeleteAccountRequest
 */
export class DeleteAccountRequest extends Message<DeleteAccountRequest> {
  constructor(data?: PartialMessage<DeleteAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.DeleteAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAccountRequest {
    return new DeleteAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAccountRequest {
    return new DeleteAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAccountRequest {
    return new DeleteAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAccountRequest | PlainMessage<DeleteAccountRequest> | undefined, b: DeleteAccountRequest | PlainMessage<DeleteAccountRequest> | undefined): boolean {
    return proto3.util.equals(DeleteAccountRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.DeleteAccountResponse
 */
export class DeleteAccountResponse extends Message<DeleteAccountResponse> {
  constructor(data?: PartialMessage<DeleteAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.DeleteAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAccountResponse {
    return new DeleteAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAccountResponse {
    return new DeleteAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAccountResponse {
    return new DeleteAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAccountResponse | PlainMessage<DeleteAccountResponse> | undefined, b: DeleteAccountResponse | PlainMessage<DeleteAccountResponse> | undefined): boolean {
    return proto3.util.equals(DeleteAccountResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.DeactivateAccountRequest
 */
export class DeactivateAccountRequest extends Message<DeactivateAccountRequest> {
  /**
   * @generated from field: google.protobuf.Duration deactivated_duration = 1;
   */
  deactivatedDuration?: Duration;

  constructor(data?: PartialMessage<DeactivateAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.DeactivateAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "deactivated_duration", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeactivateAccountRequest {
    return new DeactivateAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeactivateAccountRequest {
    return new DeactivateAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeactivateAccountRequest {
    return new DeactivateAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeactivateAccountRequest | PlainMessage<DeactivateAccountRequest> | undefined, b: DeactivateAccountRequest | PlainMessage<DeactivateAccountRequest> | undefined): boolean {
    return proto3.util.equals(DeactivateAccountRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.DeactivateAccountResponse
 */
export class DeactivateAccountResponse extends Message<DeactivateAccountResponse> {
  constructor(data?: PartialMessage<DeactivateAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.DeactivateAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeactivateAccountResponse {
    return new DeactivateAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeactivateAccountResponse {
    return new DeactivateAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeactivateAccountResponse {
    return new DeactivateAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeactivateAccountResponse | PlainMessage<DeactivateAccountResponse> | undefined, b: DeactivateAccountResponse | PlainMessage<DeactivateAccountResponse> | undefined): boolean {
    return proto3.util.equals(DeactivateAccountResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.ReactivateAccountRequest
 */
export class ReactivateAccountRequest extends Message<ReactivateAccountRequest> {
  constructor(data?: PartialMessage<ReactivateAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ReactivateAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReactivateAccountRequest {
    return new ReactivateAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReactivateAccountRequest {
    return new ReactivateAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReactivateAccountRequest {
    return new ReactivateAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReactivateAccountRequest | PlainMessage<ReactivateAccountRequest> | undefined, b: ReactivateAccountRequest | PlainMessage<ReactivateAccountRequest> | undefined): boolean {
    return proto3.util.equals(ReactivateAccountRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.ReactivateAccountResponse
 */
export class ReactivateAccountResponse extends Message<ReactivateAccountResponse> {
  constructor(data?: PartialMessage<ReactivateAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ReactivateAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReactivateAccountResponse {
    return new ReactivateAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReactivateAccountResponse {
    return new ReactivateAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReactivateAccountResponse {
    return new ReactivateAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReactivateAccountResponse | PlainMessage<ReactivateAccountResponse> | undefined, b: ReactivateAccountResponse | PlainMessage<ReactivateAccountResponse> | undefined): boolean {
    return proto3.util.equals(ReactivateAccountResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.StoreClientEventRequest
 */
export class StoreClientEventRequest extends Message<StoreClientEventRequest> {
  /**
   * @generated from oneof gdx.gateway.web.myprofile.v1.StoreClientEventRequest.event
   */
  event: {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.OnboardingCompleteClientEvent onboarding_complete = 1;
     */
    value: OnboardingCompleteClientEvent;
    case: "onboardingComplete";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.WebPushClickClientEvent web_push_click = 2;
     */
    value: WebPushClickClientEvent;
    case: "webPushClick";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.CardsViewedEvent cards_viewed = 3;
     */
    value: CardsViewedEvent;
    case: "cardsViewed";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.RouteVisitedEvent route_visited = 4;
     */
    value: RouteVisitedEvent;
    case: "routeVisited";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.CameBackEvent came_back = 6;
     */
    value: CameBackEvent;
    case: "cameBack";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.ProfileVisitedEvent visit = 7;
     */
    value: ProfileVisitedEvent;
    case: "visit";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<StoreClientEventRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.StoreClientEventRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "onboarding_complete", kind: "message", T: OnboardingCompleteClientEvent, oneof: "event" },
    { no: 2, name: "web_push_click", kind: "message", T: WebPushClickClientEvent, oneof: "event" },
    { no: 3, name: "cards_viewed", kind: "message", T: CardsViewedEvent, oneof: "event" },
    { no: 4, name: "route_visited", kind: "message", T: RouteVisitedEvent, oneof: "event" },
    { no: 6, name: "came_back", kind: "message", T: CameBackEvent, oneof: "event" },
    { no: 7, name: "visit", kind: "message", T: ProfileVisitedEvent, oneof: "event" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StoreClientEventRequest {
    return new StoreClientEventRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StoreClientEventRequest {
    return new StoreClientEventRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StoreClientEventRequest {
    return new StoreClientEventRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StoreClientEventRequest | PlainMessage<StoreClientEventRequest> | undefined, b: StoreClientEventRequest | PlainMessage<StoreClientEventRequest> | undefined): boolean {
    return proto3.util.equals(StoreClientEventRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.StoreClientEventResponse
 */
export class StoreClientEventResponse extends Message<StoreClientEventResponse> {
  constructor(data?: PartialMessage<StoreClientEventResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.StoreClientEventResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StoreClientEventResponse {
    return new StoreClientEventResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StoreClientEventResponse {
    return new StoreClientEventResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StoreClientEventResponse {
    return new StoreClientEventResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StoreClientEventResponse | PlainMessage<StoreClientEventResponse> | undefined, b: StoreClientEventResponse | PlainMessage<StoreClientEventResponse> | undefined): boolean {
    return proto3.util.equals(StoreClientEventResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SubmitOffboardingSurveyRequest
 */
export class SubmitOffboardingSurveyRequest extends Message<SubmitOffboardingSurveyRequest> {
  /**
   * Populated by UI due to a constrained nature of ENUMS.
   *
   * @generated from field: string response = 1;
   */
  response = "";

  /**
   * @generated from field: gdx.gateway.web.myprofile.v1.SurveyType type = 2;
   */
  type = SurveyType.INVALID;

  /**
   * User's comment if `other` option has been chosen.
   *
   * @generated from field: string response_description = 3;
   */
  responseDescription = "";

  constructor(data?: PartialMessage<SubmitOffboardingSurveyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SubmitOffboardingSurveyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "response", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(SurveyType) },
    { no: 3, name: "response_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitOffboardingSurveyRequest {
    return new SubmitOffboardingSurveyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitOffboardingSurveyRequest {
    return new SubmitOffboardingSurveyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitOffboardingSurveyRequest {
    return new SubmitOffboardingSurveyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitOffboardingSurveyRequest | PlainMessage<SubmitOffboardingSurveyRequest> | undefined, b: SubmitOffboardingSurveyRequest | PlainMessage<SubmitOffboardingSurveyRequest> | undefined): boolean {
    return proto3.util.equals(SubmitOffboardingSurveyRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.SubmitOffboardingSurveyResponse
 */
export class SubmitOffboardingSurveyResponse extends Message<SubmitOffboardingSurveyResponse> {
  constructor(data?: PartialMessage<SubmitOffboardingSurveyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.SubmitOffboardingSurveyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitOffboardingSurveyResponse {
    return new SubmitOffboardingSurveyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitOffboardingSurveyResponse {
    return new SubmitOffboardingSurveyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitOffboardingSurveyResponse {
    return new SubmitOffboardingSurveyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitOffboardingSurveyResponse | PlainMessage<SubmitOffboardingSurveyResponse> | undefined, b: SubmitOffboardingSurveyResponse | PlainMessage<SubmitOffboardingSurveyResponse> | undefined): boolean {
    return proto3.util.equals(SubmitOffboardingSurveyResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetOneTimeHashRequest
 */
export class GetOneTimeHashRequest extends Message<GetOneTimeHashRequest> {
  constructor(data?: PartialMessage<GetOneTimeHashRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetOneTimeHashRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOneTimeHashRequest {
    return new GetOneTimeHashRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOneTimeHashRequest {
    return new GetOneTimeHashRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOneTimeHashRequest {
    return new GetOneTimeHashRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOneTimeHashRequest | PlainMessage<GetOneTimeHashRequest> | undefined, b: GetOneTimeHashRequest | PlainMessage<GetOneTimeHashRequest> | undefined): boolean {
    return proto3.util.equals(GetOneTimeHashRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetOneTimeHashResponse
 */
export class GetOneTimeHashResponse extends Message<GetOneTimeHashResponse> {
  /**
   * @generated from field: string hash = 1;
   */
  hash = "";

  constructor(data?: PartialMessage<GetOneTimeHashResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetOneTimeHashResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOneTimeHashResponse {
    return new GetOneTimeHashResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOneTimeHashResponse {
    return new GetOneTimeHashResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOneTimeHashResponse {
    return new GetOneTimeHashResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOneTimeHashResponse | PlainMessage<GetOneTimeHashResponse> | undefined, b: GetOneTimeHashResponse | PlainMessage<GetOneTimeHashResponse> | undefined): boolean {
    return proto3.util.equals(GetOneTimeHashResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetFacebookTrackingParamsRequest
 */
export class GetFacebookTrackingParamsRequest extends Message<GetFacebookTrackingParamsRequest> {
  constructor(data?: PartialMessage<GetFacebookTrackingParamsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetFacebookTrackingParamsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFacebookTrackingParamsRequest {
    return new GetFacebookTrackingParamsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFacebookTrackingParamsRequest {
    return new GetFacebookTrackingParamsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFacebookTrackingParamsRequest {
    return new GetFacebookTrackingParamsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFacebookTrackingParamsRequest | PlainMessage<GetFacebookTrackingParamsRequest> | undefined, b: GetFacebookTrackingParamsRequest | PlainMessage<GetFacebookTrackingParamsRequest> | undefined): boolean {
    return proto3.util.equals(GetFacebookTrackingParamsRequest, a, b);
  }
}

/**
 * List of possible params are here https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/customer-information-parameters.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.GetFacebookTrackingParamsResponse
 */
export class GetFacebookTrackingParamsResponse extends Message<GetFacebookTrackingParamsResponse> {
  /**
   * All params should be SHA-256 hashed.
   *
   * @generated from field: string external_id = 1;
   */
  externalId = "";

  /**
   * @generated from field: string em = 2;
   */
  em = "";

  /**
   * @generated from field: string ge = 3;
   */
  ge = "";

  /**
   * @generated from field: string ct = 4;
   */
  ct = "";

  /**
   * @generated from field: string st = 5;
   */
  st = "";

  /**
   * @generated from field: string country = 6;
   */
  country = "";

  /**
   * @generated from field: string db = 7;
   */
  db = "";

  /**
   * @generated from field: string fn = 8;
   */
  fn = "";

  /**
   * @generated from field: string ln = 9;
   */
  ln = "";

  /**
   * @generated from field: string zp = 10;
   */
  zp = "";

  constructor(data?: PartialMessage<GetFacebookTrackingParamsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetFacebookTrackingParamsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "external_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "em", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ge", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ct", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "st", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "db", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "fn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "ln", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "zp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFacebookTrackingParamsResponse {
    return new GetFacebookTrackingParamsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFacebookTrackingParamsResponse {
    return new GetFacebookTrackingParamsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFacebookTrackingParamsResponse {
    return new GetFacebookTrackingParamsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFacebookTrackingParamsResponse | PlainMessage<GetFacebookTrackingParamsResponse> | undefined, b: GetFacebookTrackingParamsResponse | PlainMessage<GetFacebookTrackingParamsResponse> | undefined): boolean {
    return proto3.util.equals(GetFacebookTrackingParamsResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetIsSafeRequest
 */
export class GetIsSafeRequest extends Message<GetIsSafeRequest> {
  /**
   * @generated from field: string event_name = 1;
   */
  eventName = "";

  constructor(data?: PartialMessage<GetIsSafeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetIsSafeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIsSafeRequest {
    return new GetIsSafeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIsSafeRequest {
    return new GetIsSafeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIsSafeRequest {
    return new GetIsSafeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetIsSafeRequest | PlainMessage<GetIsSafeRequest> | undefined, b: GetIsSafeRequest | PlainMessage<GetIsSafeRequest> | undefined): boolean {
    return proto3.util.equals(GetIsSafeRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetIsSafeResponse
 */
export class GetIsSafeResponse extends Message<GetIsSafeResponse> {
  /**
   * This field is base on fraud score.
   *
   * @generated from field: bool is_safe = 1;
   */
  isSafe = false;

  constructor(data?: PartialMessage<GetIsSafeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetIsSafeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_safe", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIsSafeResponse {
    return new GetIsSafeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIsSafeResponse {
    return new GetIsSafeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIsSafeResponse {
    return new GetIsSafeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetIsSafeResponse | PlainMessage<GetIsSafeResponse> | undefined, b: GetIsSafeResponse | PlainMessage<GetIsSafeResponse> | undefined): boolean {
    return proto3.util.equals(GetIsSafeResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.VerifyEmailRequest
 */
export class VerifyEmailRequest extends Message<VerifyEmailRequest> {
  constructor(data?: PartialMessage<VerifyEmailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.VerifyEmailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyEmailRequest {
    return new VerifyEmailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyEmailRequest {
    return new VerifyEmailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyEmailRequest {
    return new VerifyEmailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyEmailRequest | PlainMessage<VerifyEmailRequest> | undefined, b: VerifyEmailRequest | PlainMessage<VerifyEmailRequest> | undefined): boolean {
    return proto3.util.equals(VerifyEmailRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.VerifyEmailResponse
 */
export class VerifyEmailResponse extends Message<VerifyEmailResponse> {
  constructor(data?: PartialMessage<VerifyEmailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.VerifyEmailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyEmailResponse {
    return new VerifyEmailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyEmailResponse {
    return new VerifyEmailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyEmailResponse {
    return new VerifyEmailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyEmailResponse | PlainMessage<VerifyEmailResponse> | undefined, b: VerifyEmailResponse | PlainMessage<VerifyEmailResponse> | undefined): boolean {
    return proto3.util.equals(VerifyEmailResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetIsRecordableRequest
 */
export class GetIsRecordableRequest extends Message<GetIsRecordableRequest> {
  constructor(data?: PartialMessage<GetIsRecordableRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetIsRecordableRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIsRecordableRequest {
    return new GetIsRecordableRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIsRecordableRequest {
    return new GetIsRecordableRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIsRecordableRequest {
    return new GetIsRecordableRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetIsRecordableRequest | PlainMessage<GetIsRecordableRequest> | undefined, b: GetIsRecordableRequest | PlainMessage<GetIsRecordableRequest> | undefined): boolean {
    return proto3.util.equals(GetIsRecordableRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.myprofile.v1.GetIsRecordableResponse
 */
export class GetIsRecordableResponse extends Message<GetIsRecordableResponse> {
  constructor(data?: PartialMessage<GetIsRecordableResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.GetIsRecordableResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIsRecordableResponse {
    return new GetIsRecordableResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIsRecordableResponse {
    return new GetIsRecordableResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIsRecordableResponse {
    return new GetIsRecordableResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetIsRecordableResponse | PlainMessage<GetIsRecordableResponse> | undefined, b: GetIsRecordableResponse | PlainMessage<GetIsRecordableResponse> | undefined): boolean {
    return proto3.util.equals(GetIsRecordableResponse, a, b);
  }
}

